
<script>import { Σ } from "../../common/clsx/index";
import { getContext } from "../../common/svelte/index";
import { css } from "emotion";
export let span = 24;
export let offset = 0;
export let className = "";
const gutter = getContext("gutter");
let style = "";

$: {
  const gutterStyle = Boolean($gutter) ? css`
                  padding: 0px ${$gutter / 2}px;
              ` : "";
  style = Σ("el-col", `el-col-${span}`, gutterStyle, {
    [`el-col-offset-${offset}`]: offset !== 0
  }, className);
}</script>


<div class={style}>
        <slot />
    </div>


<style>

</style>